import React, { Component } from "react";
import { observer, inject } from "mobx-react";

class CustomerPanel extends Component {
  render() {
    const { stores } = this.props;
    const user = stores.currentUser.user;
    const customer = stores.currentUser.customer;

    let editCompanyDetail = null;
    if (customer) {
      if (user.isPrimaryUser || user.isAdmin) editCompanyDetail = <a href={"#customer-detail?id=" + customer.Id}>Edit company details</a>;
    }

    return (
      <div className="col-sm-6">
        <div className="well">
          <div className="row">
            <div className="col-sm-6">
              <h2>{customer.Name}</h2>
              <a href={"#users-list?customerId=" + customer.Id}>Users</a>
              <br />
              <a href={"#licenses-list?customerId=" + customer.Id}>Licenses</a>
              <br /> <br />
              {editCompanyDetail}
            </div>
            <div className="col-sm-6">
              <img className="home-icon" src="images/company.png" alt="company" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default inject("stores")(observer(CustomerPanel));



// WEBPACK FOOTER //
// ./src/Components/CustomerPanel/CustomerPanel.js